export default __webpack_public_path__ + "static/media/-W_8XJnvUD7dzB2Cy_gIaWMuUZctdg.05fbc33a.woff2";